class ModalEvent {
  async onSubmitConfigureChatbot() {
    let instruction = document.getElementById("input_intruction_chatbot").value;
    let screening_question = document.getElementById("input_screening_question_chatbot").value;
    let from_date = document.getElementById("from_meet_date").value;
    let to_date = document.getElementById("to_meet_date").value;
    let from_meet_time_start = document.getElementById("from_meet_time_start").value;
    let from_meet_time_end = document.getElementById("from_meet_time_end").value;
    let to_meet_time_start = document.getElementById("to_meet_time_start").value;
    let to_meet_time_end = document.getElementById("to_meet_time_end").value;
    console.log({ input_intruction_chatbot, input_screening_question_chatbot, from_meet_date, to_meet_date, from_meet_time_start, from_meet_time_end, to_meet_time_start, to_meet_time_end });

    sessionStorage["current_table"];
    if (input_intruction_chatbot) {
    }

    let time_slots = to_meet_time_start + "," + to_meet_time_end;
    let requestBody = {
      instruction,
      screening_question,
      from_date,
      to_date,
      time_slots,
      job_id: JSON.parse(sessionStorage["current_table"])["table_id"],
    };
    try {
      let response = await AjaxAPICall(eUrl.chatBotConfig, eMethod.post, requestBody);
      console.log("chatbot config called");
      console.log({ response });
      $(configure_chatbot_modal).modal("hide");
    } catch (error) {
      $(configure_chatbot_modal).modal("hide");
      console.log("error in submit configure chatbot");
      alert("error");
    }
  }
}

/**
 * This function adds two numbers.
 * @param url - with base url (arxena.com/endPoint).
 * @param method - reuqest method.
 * @returns body javascript object which later on stringfy by function before sending request
 */
function AjaxAPICall(url, method = "post", body) {
  console.log("Ajax API Call called");
  console.log("url::", url, "request body ::", body);
  return new Promise((resolve, reject) => {
    const authToken = Cookies.getJSON()["auth_token"];
    const headers = new Headers({
      "Content-Type": "application/json",
      Authorization: `Bearer ${authToken}`,
    });
    const request = new Request(url, {
      method: method,
      headers: headers,
      body: JSON.stringify(body),
    });

    fetch(request)
      .then((response) => {
        // console.log({response});
        if (!response.ok) {
          throw new Error(`HTTP error! Status: ${response.status}`);
        }
        return response.json();
      })
      .then((data) => {
        if (data?.status == "fail") {
          $(".modal:visible").modal("hide");
          document.getElementById("general_message_title").innerText = "Something went wrong!!!";
          document.getElementById("general_message_text").innerText = "Please try again after some time or contact us";
          $(general_message_modal).modal("show");
        } else {
          console.log({ response: data });
          resolve(data);
        }
      })
      .catch((error) => {
        if (error.includes("signed out") || error.includes("Status: 599")) {
          new PageContents().tokenExpireAction();
        }
        if (error?.message?.includes("signed out")) {
          new PageContents().tokenExpireAction();
        } else if (error.name === "SyntaxError") {
          reject(new Error("Error parsing JSON data"));
        } else if (error.message.startsWith("HTTP error")) {
          reject(new Error(`API Error: ${error.message}`));
        } else {
          reject(new Error("Network error or other issue"));
        }
      });
  });
}

// ===========================================================================
function showToastMessage(toastMessage, task_id, progress_value = 0) {
  var isToastExist = false;
  progress_value != "error" && (isToastExist = document.getElementById(`progress_bar_${task_id}`));
  if (isToastExist && progress_value != "Task Finished") {
    updateProgressBar(task_id, progress_value);
  } else {
    const toastContainer = document.getElementById("toast-container");

    // Create toast message and progress bar elements
    const toast = document.createElement("div");
    toast.className = "toast toast-message";

    const progressBar = document.createElement("div");
    progressBar.className = "progress-bar";
    const progress = document.createElement("div");
    progress.id = `progress_bar_${task_id}`;
    progress.className = "progress";
    progress.style.width = 0 + "%";
    progressBar.appendChild(progress);

    const closeBtn = document.createElement("span");
    closeBtn.className = "close-btn";
    closeBtn.innerHTML = "&#10006;";
    closeBtn.style.fontSize = "13pt";
    closeBtn.onclick = function () {
      toast.style.opacity = "0";
      toast.style.color = "#757575";
      toast.style.transform = "translateY(-20px)";
      setTimeout(() => {
        toast.remove();
      }, 300);
    };

    const message = document.createElement("div");
    message.innerText = toastMessage;
    message.style.fontSize = "12pt";
    toast.style.opacity = "1";
    toast.style.transform = "translateY(0)";

    toast.appendChild(message);
    toast.appendChild(closeBtn);
    progress_value != "error" && progress_value != "Task Finished" && toast.appendChild(progressBar);

    toastContainer.appendChild(toast);
    progress_value != "error" && progress_value != "Task Finished" && updateProgressBar(task_id, progress_value);
  }
}

function updateProgressBar(task_id, progress) {
  let progressBar = document.getElementById(`progress_bar_${task_id}`);
  const interval = setInterval(() => {
    let width = parseInt(progressBar.style.width);
    if (width <= progress) progressBar.style.width = ++width + "%";
    else clearInterval(interval);
  }, 100);
}

export { ModalEvent, AjaxAPICall, showToastMessage, updateProgressBar };
if (typeof window !== 'undefined') {
  window.ModalEvent = ModalEvent;
  window.AjaxAPICall = AjaxAPICall;
  window.showToastMessage = showToastMessage;
  window.updateProgressBar = updateProgressBar;
}
